import * as React from 'react';
import { usePrivateSteppingContext } from '../../Context/PrivateSteppingContext.js';
import { ExpanderContainer } from './components/Expander/ExpanderContainer.js';
import { TopBar } from './components/TopBar/TopBar.js';

const ConfiguratorFooter = ()=>{
    const { footerTopBarContent , footerExpanderContent  } = usePrivateSteppingContext();
    return /*#__PURE__*/ React.createElement("footer", {
        "data-t": "configurator-footer",
        className: "configurator-footer"
    }, /*#__PURE__*/ React.createElement(TopBar, null, footerTopBarContent), /*#__PURE__*/ React.createElement(ExpanderContainer, null, footerExpanderContent));
};

export { ConfiguratorFooter };
//# sourceMappingURL=ConfiguratorFooter.js.map
